import * as React from 'react';
import SvgIcon from "../svg-icon/SvgIcon";

export const Error = (props) => {
    return (
        <SvgIcon {...props} viewBox="0 0 1024 1024">
            <path xmlns="http://www.w3.org/2000/svg" d="M512 1024C794.769792 1024 1024 794.769792 1024 512 1024 229.230208 794.769792 0 512 0 229.230208 0 0 229.230208 0 512 0 794.769792 229.230208 1024 512 1024ZM343.754675 307.2 515.024998 478.534374 686.953114 307.2 723.325005 344.796877 551.521869 515.595315 722.44375 686.596864 686.118758 722.957824 515.09376 551.690624 343.754675 722.678118 307.2 686.335949 479.029683 515.275008 307.510938 344.379699 343.754675 307.2Z"/>
        </SvgIcon>
    );
};

export default Error;